import { gql, useMutation } from '@apollo/client';

const sendWhatsappVerificationToken = gql`
  mutation sendWhatsappVerificationToken {
    sendWhatsappVerificationToken
  }
`;

export const useSendWhatsappVerificationToken = () =>
  useMutation<void>(sendWhatsappVerificationToken);
